import { Layout } from "Components/Layout/Layout";
import { BidsList } from 'Containers/Bids/BidsList/BidsList';

export const BidsListPage = () => {
  return (
    <Layout>
      <BidsList />
    </Layout>
  );
};
